import { Controller } from 'stimulus'

// Edit on the Sample Storage screen: fetches the box's Edit dialog (the same
// one the job's Samples tab uses) and opens it here, so the list, its
// filters, and its selection stay put. Saving comes back to this list. If
// the dialog can't be loaded (no permission to change that job), the link
// falls through to the job.
export default class extends Controller {
  static targets = ['holder']

  async open(event) {
    event.preventDefault()
    const link = event.currentTarget

    try {
      const response = await fetch(link.dataset.dialogUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html' },
        credentials: 'same-origin'
      })
      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      this.holderTarget.innerHTML = await response.text()
    } catch (error) {
      window.location.href = link.href
    }
  }
}
